<template>
    <div class="hundred">
        <b-modal id="gif-modal" no-close-on-esc no-close-on-backdrop and hide-header-close centered>
            <template v-slot:modal-header>
                &nbsp;
            </template>
            <div class="d-block text-center">
                <img src = "../assets/loading.gif">
            </div>
            <template v-slot:modal-footer>
                &nbsp;
            </template>
        </b-modal>
        <b-modal id="normal-modal" centered>
            <div class="d-block text-center">
                {{notification}}
            </div>
        </b-modal>
        <b-modal id="html-modal" centered>
            <div class="d-block text-center" v-html = "html">
            </div>
        </b-modal>
        <LanguageChoice class=""></LanguageChoice>
    </div>
</template>

<script>
import LanguageChoice from "./Manager/LanguageChoice";
export default{
	components:{
		LanguageChoice
	},
    data(){
        return{
            notification: "",
            html: ""
        }
    },
    mounted(){
        global.myNotify = {
            show:(string) =>{
                this.notification = string || "";
                this.$bvModal.show('normal-modal');
            },
            close:()=>{
                this.$bvModal.hide('normal-modal');
            },
            showHTML:(string) =>{
                this.html = string || "";
                this.$bvModal.show('html-modal');
            },
            closeHTML:()=>{
                this.$bvModal.hide('html-modal');
            },
            loading: (string)=>{
                this.notification = string || "";
                this.$bvModal.show('gif-modal');
            },
            loadStop: ()=>{
                this.$bvModal.hide('gif-modal');
            },
            toast: (string, duration)=>{
                this.$toasted.show(string, { 
                    theme: "outline", 
                    position: "top-right", 
                    className: ['yellowBG'],
                    duration : duration || 3000
                });
            },
            startSound: ()=>{                
                var player = $("#orderNotificationPlayer")[0];
                if (player != undefined){
                    player.play();
                    // console.log("STARTING: ");
                    // console.log(player);
                }
            },
            stopSound: ()=>{
                var player = $("#orderNotificationPlayer")[0];
                if (player != undefined){
                    player.pause();
                    // console.log("PAUSING: ");
                    // console.log(player);
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Notification.vue